const ProductController = function ($scope, $sce) {
  /**
   * @param {Product} product
   * @return {string}
   */
  $scope.getDescription = function (product) {
    var description = '';
    if (product.detailData && product.detailData.beschreibung) {
      description = $sce.trustAsHtml(product.detailData.beschreibung);
    }
    return description;
  };

  $scope.getActivePicture = function (product) {
    return product.activeImage ? product.activeImage : product.image;
  };

  $scope.setActivePicture = function (product, img) {
    product.activeImage = img;
    return this;
  };

};

export default ProductController;